import { IntensityLevelsManager } from "@/components/admin/IntensityLevelsManager";

export function SettingsIntensityPage() {
  return <IntensityLevelsManager />;
}
